import React, { useCallback } from 'react';
import classnames from 'classnames';

import { useGlMap } from '../../../contexts/context';
import Icon from '../../../../common/components/icon/Icon';

import './NavigationControl.scss';

export interface NavigationProps {
  className?: string;
}

const NavigationControl = ({ className }: NavigationProps) => {
  const glMap = useGlMap();

  const handleZoomIn = useCallback(
    (e) => {
      if (glMap) {
        glMap.zoomIn({}, { originalEvent: e });
      }
    },
    [glMap],
  );

  const handleZoomOut = useCallback(
    (e) => {
      if (glMap) {
        glMap.zoomOut({}, { originalEvent: e });
      }
    },
    [glMap],
  );

  return (
    <div className={classnames('navigation-control', className)}>
      <button
        className="navigation-control__zoom-in-button"
        type="button"
        onClick={handleZoomIn}
      >
        <Icon className="navigation-control__zoom-in-icon" name="plus" />
      </button>
      <button
        className="navigation-control__zoom-out-button"
        type="button"
        onClick={handleZoomOut}
      >
        <Icon className="navigation-control__zoom-out-icon" name="minus" />
      </button>
    </div>
  );
};

export default NavigationControl;
